<template>
    <div class="vx-row">
      <vs-card>
        <div slot="header">
          <h4>Recherche</h4>
        </div>
        <div>
          <vs-row>
            <vs-col class="mr-2" vs-w="3">
              <vs-select class="w-full"
                placeholder="Selectionner un mois"
                label="Mois début"
                autocomplete
                v-model="first_month"
              >
                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in month" />
              </vs-select>
            </vs-col>
            <vs-col vs-w="3" class="mr-2">
              <vs-select class="w-full"
                placeholder="Selectionner un mois"
                label="Mois fin"
                autocomplete
                v-model="end_month"
              >
                <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in month" />
              </vs-select>
            </vs-col>
            <vs-col vs-w="2" class="mr-2">
              <vs-select class="w-full"
                         placeholder="Selectionner un mois"
                         label="Période"
                         autocomplete
                         v-model="period"
              >
                <vs-select-item :key="index" :value="item" :text="item" v-for="(item,index) in periods" />
              </vs-select>
            </vs-col>
            <vs-col vs-w="3">
              <vs-button style="margin-top: 15px" color="primary" type="border">Exporter</vs-button>
            </vs-col>
          </vs-row>
        </div>
      </vs-card>
    </div>
</template>

<script>
    export default {
        name: "agent",
      data: () => ({
        first_month: 1,
        end_month: 12,
        period: 2020,
        periods: [2020,2021,2022,2023,2024,2025,2026,2027,2028,2029,2030,2031,2032,2033],
        month: [
          {name: 'Janvier', id: 1},
          {name: 'Février', id: 2},
          {name: 'Mars', id: 3},
          {name: 'Avril', id: 4},
          {name: 'Mai', id: 5},
          {name: 'Juin', id: 6},
          {name: 'Juillet', id: 7},
          {name: 'Août', id: 8},
          {name: 'Septembre', id: 9},
          {name: 'Octobre', id: 10},
          {name: 'Novembre', id: 11},
          {name: 'Décembre', id: 12},
        ]
      })
    }
</script>

<style scoped>

</style>
